const SearchIcon = () => (
  <svg className="w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
)

const ClearIcon = () => (
  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
)

/**
 * Controlled search input with clear button.
 * @param {{ value: string, onChange: (val: string) => void }} props
 */
const SearchBar = ({ value, onChange }) => (
  <div className="relative flex-1 max-w-2xl">
    <span className="absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none">
      <SearchIcon />
    </span>

    <input
      type="search"
      placeholder="Search deals, products, brands…"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Search deals"
      className="w-full pl-10 pr-10 py-2.5 text-sm
        bg-slate-50 border border-slate-200 rounded-xl
        focus:outline-none focus:ring-2 focus:ring-brand-400 focus:border-transparent focus:bg-white
        placeholder:text-slate-400 text-slate-800
        transition-all duration-200"
    />

    {value && (
      <button
        onClick={() => onChange('')}
        aria-label="Clear search"
        className="absolute right-3 top-1/2 -translate-y-1/2
          text-slate-400 hover:text-slate-600 transition-colors"
      >
        <ClearIcon />
      </button>
    )}
  </div>
)

export default SearchBar
